import { useEffect, useState } from "react";

/**
 * Instante real do navegador (`Date` compatível com `getTime()` de ISO UTC do backend).
 * Não usar `BrazilDate.now()` aqui: `toZonedTime` altera o epoch interno do `Date` e quebra
 * `partitionProntosRetiradaTv` (dia civil vs `diaHojeBr` e deltas `elapsedMs`) — sem transição Prep→Pronto → sem modal/alarme.
 */
export function useTvRetiradaRelogio(intervalMs = 15000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
}
